// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"647":"0a90ccdf","720":"b07b0f4e"}[chunkId] + ".js";
};